import { useMemo } from "react";
import { Link } from "react-router-dom";
import { Users, Store } from "lucide-react";
import { fmtDate } from "@/lib/format";
import SharedGauge from "@/components/enhancer/SharedGauge";

// People who have booked with this enhancer, built from their bookings.
export default function MyClients({ bookings }) {
  const clients = useMemo(() => {
    const by = {};
    bookings.forEach((b) => {
      const key = (b.user_email || b.email || b.name || "").toLowerCase();
      if (!key) return;
      const c = by[key] || (by[key] = { key, name: b.name || b.user_email || b.email, email: b.user_email || b.email || "", visits: 0, last: "", next: "" });
      if (b.status === "cancelled") return;
      c.visits += 1;
      const today = new Date().toISOString().slice(0, 10);
      if (b.date < today && b.date > c.last) c.last = b.date;
      if (b.date >= today && (!c.next || b.date < c.next)) c.next = b.date;
    });
    return Object.values(by).sort((a, b) => (b.next || b.last).localeCompare(a.next || a.last));
  }, [bookings]);
  return (
    <section data-testid="enh-clients-panel" className="space-y-5">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <h2 className="font-serif text-2xl text-[#1A242B]">My clients</h2>
          <p className="text-sm text-[#4A5D6B]">Everyone who has booked with you. Open the front desk to see full records or take a payment.</p>
        </div>
        <Link to="/pos?tab=clients" data-testid="enh-clients-open-pos" className="eyw-btn-ghost !py-2 text-sm"><Store size={15} /> Full client records</Link>
      </div>
      {clients.length === 0 ? <p className="text-sm text-[#4A5D6B]" data-testid="enh-clients-empty">No clients yet. They'll appear here after their first booking.</p> : (
        <div className="eyw-card divide-y divide-[#E5E0D8]">
          {clients.map((c) => (
            <div key={c.key} className="flex flex-wrap items-center gap-3 px-5 py-3" data-testid={`enh-client-${c.key}`}>
              <Users size={16} className="text-[#8FA89B]" />
              <div className="flex-1 min-w-[180px]">
                <p className="text-sm font-medium text-[#1A242B]">{c.name}</p>
                {c.email && <p className="text-xs text-[#8FA89B]">{c.email}</p>}
              </div>
              <span className="text-xs text-[#4A5D6B]">{c.visits} booking{c.visits === 1 ? "" : "s"}</span>
              <span className="text-xs text-[#4A5D6B] w-36">{c.next ? `Next: ${fmtDate(c.next)}` : c.last ? `Last: ${fmtDate(c.last)}` : ""}</span>
            </div>
          ))}
        </div>
      )}
      <SharedGauge />
    </section>
  );
}
